import i18next from 'i18next';
import React from 'react';
import { render } from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import './scss/main.scss';

import { SnackbarProvider } from 'notistack';

import commonEn from './translations/en/common.json';
import commonEs from './translations/es/common.json';

// import i18n from './i18n';

import App from './App';
import { loadConfig } from './config';

i18next.init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem('language') ? localStorage.getItem('language').toLowerCase() : 'es',
  resources: {
    en: {
      common: commonEn,
    },
    es: {
      common: commonEs,
    },
  },
});

loadConfig().then(() => {
  console.log('Load config then');
  render(
    <SnackbarProvider maxSnack={3}>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </SnackbarProvider>,
    document.getElementById('root'),
  );
});
